import React, { useState } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import useQuery from '../../modules/react/hooks/useQuery';
import useMutation from '../../modules/react/hooks/useMutation';
import Component from '../components/SettingsActions/SettingsActions';

const GET_SITE_ACTIVATION = gql`
  query GetSiteActivation {
    currentSite {
      id
      activated
    }
  }
`;

const DEACTIVATE_SITE = gql`
  mutation DeactivateSite {
    currentSiteDeactivate {
      success
      userErrors {
        code
        message
      }
    }
  }
`;

const propTypes = {
  setAlert: PropTypes.func.isRequired,
};

const defaultProps = {};

const HostnameCertSettingsActions = ({ setAlert }) => {
  const [alertBanner, setAlertBanner] = useState();

  const [
    deactivateSite,
    { loading: deactivateSiteLoading },
  ] = useMutation(DEACTIVATE_SITE);

  const {
    data: siteActivationData,
    loading: siteActivationLoading,
    errors: siteActivationErrors,
  } = useQuery(GET_SITE_ACTIVATION);

  if (siteActivationLoading || siteActivationErrors?.length || !siteActivationData) {
    return null;
  }

  const { currentSite: { activated } } = siteActivationData;

  const actions = activated
    ? [{
      name: 'deactivateSite',
      text: 'Deactivate Site',
      context: 'error',
      confirmationModal: {
        title: 'Are you sure you want to deactivate this site?',
        text: 'Deactivating Domains & SSL Certificates will delete all stored domain and SSL data across this site. It will also un-publish any live pages and put them into draft mode. This should only be done for customers who are no longer clients.',
        accept: 'Deactivate',
      },
      handler: async () => {
        const {
          data: { currentSiteDeactivate: { success, userErrors } },
        } = await deactivateSite();
        if (success) {
          return setAlertBanner({
            context: 'success',
            icon: 'success',
            text: 'Success! The site has been deactivated.',
          });
        }
        if (userErrors?.length) {
          return setAlertBanner({
            context: 'danger',
            icon: 'info',
            text: `Error! There was a problem deactivating the site. ${userErrors[0].message}`,
          });
        }
        return setAlertBanner({
          context: 'danger',
          icon: 'info',
          text: 'Error! There was a problem deactivating the site.',
        });
      },
      loading: deactivateSiteLoading,
    }]
    : [{}];

  return (
    <Component
      actions={actions}
      setAlert={setAlert}
      alertBanner={alertBanner}
    />
  );
};

HostnameCertSettingsActions.propTypes = propTypes;
HostnameCertSettingsActions.defaultProps = defaultProps;

export default HostnameCertSettingsActions;
